"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/// <reference types="gapi.youtube" />
var object_1 = require("@wix/wix-vod-shared/dist/src/common/utils/object");
var transcoding_statuses_1 = require("@wix/wix-vod-constants/dist/common/transcoding-statuses");
var video_sources_1 = require("@wix/wix-vod-constants/dist/common/video-sources");
var video_deal_info_1 = require("@wix/wix-vod-constants/dist/common/video-deal-info");
var get_thumbnail_1 = tslib_1.__importDefault(require("./get-thumbnail"));
var time_1 = require("@wix/wix-vod-shared/dist/src/common/utils/time");
function parseYoutubeVideo(videoData) {
    var _a = videoData.player, player = _a === void 0 ? {} : _a, _b = videoData.snippet, snippet = _b === void 0 ? {} : _b, _c = videoData.contentDetails, contentDetails = _c === void 0 ? {} : _c;
    var maybeExternalId = videoData.id;
    var embedHtml = player.embedHtml;
    var channelId = snippet.channelId, title = snippet.title, description = snippet.description, thumbnails = snippet.thumbnails, tags = snippet.tags, category = snippet.category, publishedAt = snippet.publishedAt;
    var duration = contentDetails.duration, videoId = contentDetails.videoId;
    var width = embedHtml && Number(embedHtml.match(/width="(\d+)/)[1]);
    var height = embedHtml && Number(embedHtml.match(/height="(\d+)/)[1]);
    var categories = category ? [category] : [];
    var externalId = maybeExternalId;
    // >_<
    if (_.isObject(maybeExternalId)) {
        var objectVideoId = maybeExternalId.videoId;
        externalId = objectVideoId;
    }
    externalId = externalId || videoId;
    var mediaExternUrl = "//www.youtube.com/embed/" + externalId;
    var coverUrl = get_thumbnail_1.default(thumbnails);
    var durationSec;
    var durationStr;
    if (duration && duration !== 'P0D') {
        durationSec = time_1.convertISO8601ToSS(duration);
        durationStr = time_1.convertISO8601ToMMSS(duration);
    }
    return object_1.removeUndefinedValues({
        externalId: externalId,
        coverUrl: coverUrl,
        width: width,
        height: height,
        description: description,
        title: title,
        tags: tags,
        categories: categories,
        mediaExternUrl: mediaExternUrl,
        mediaStatus: transcoding_statuses_1.TRANSCODING_STATUSES.READY,
        channelId: channelId,
        dealInfo: video_deal_info_1.FREE_VIDEO_DEAL_INFO,
        durationSec: durationSec,
        durationStr: durationStr,
        videoSource: video_sources_1.VIDEO_SOURCES.YOUTUBE,
        datePublish: publishedAt,
    });
}
exports.default = parseYoutubeVideo;
//# sourceMappingURL=video.js.map